import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminClientDashboard from "@/pages/AdminClientDashboard";
import TeamManagement from "@/pages/TeamManagement";
import ClientPlan from "@/pages/ClientPlan";
import PostDetail from "@/pages/PostDetail";
import TasksPage from "@/pages/TasksPage";
import "@/App.css";

function RequireAuth({ children, role }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
        <div className="text-[#5C4A43] text-sm tracking-wide">A carregar…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  // Block client from accessing /admin
  return children;
}

function AdminGuard({ children }) {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "client") return <Navigate to={`/cliente/${user.id}`} replace />;
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "client") return <Navigate to={`/cliente/${user.id}`} replace />;
  return <Navigate to="/admin" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/admin"
              element={
                <AdminGuard>
                  <AdminDashboard />
                </AdminGuard>
              }
            />
            <Route
              path="/admin/equipa"
              element={
                <RequireAuth role="admin">
                  <TeamManagement />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/dashboard/:clientId"
              element={
                <RequireAuth role="admin">
                  <AdminClientDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/cliente/:clientId"
              element={
                <RequireAuth>
                  <ClientPlan />
                </RequireAuth>
              }
            />
            <Route
              path="/post/:postId"
              element={
                <RequireAuth>
                  <PostDetail />
                </RequireAuth>
              }
            />
            <Route
              path="/tarefas"
              element={
                <AdminGuard>
                  <TasksPage />
                </AdminGuard>
              }
            />
            <Route path="/" element={<HomeRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
